import { BaseCaller } from "./api";

export default class ComanyApi {
  private caller: BaseCaller;

  constructor(caller: BaseCaller) {
    this.caller = caller;
  }

  public list(): Promise<any> {
    return this.caller.get("company/");
  }

  public getCurrent(companyId: number): Promise<any> {
    return this.caller.get(`company/${companyId}/current/`);
  }

  save(data: any) {
    if (data.id) {
      return this.caller.put(`company/${data.id}`, data);
    } else {
      return this.caller.post("company/", data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/company-api.ts